// @flow

import React, { type Node } from 'react';
import {useTranslation} from 'react-i18next';
import {ErrorLabel} from '@tectonics/look-and-feel/volcanes/molecules/error-label';
import {serverErrorMessage} from '@tectonics/prs/validation';
import type {ValidationMessageProps} from '@tectonics/commons/customer-form/types';

export function GenericValidationMessage({ validationError }: ValidationMessageProps): Node {
  const { t } = useTranslation('opened-page');

  switch (validationError.id) {
    case 'server-error':
      return (
        <ErrorLabel>
          {serverErrorMessage(validationError.payload)}
        </ErrorLabel>
      );

    default:
      return (
        <ErrorLabel>
          {t('volcanes.customerForm.validationError.defaultErrorLabel')}
        </ErrorLabel>
      );
  }
}
